import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';
import { menu } from '../../data';


class AdvisoryGroups extends React.Component<any, any> {

    showItem(name: string) {
            if (name == "Indigenous Advisory Group") {
                return this.props.showIndigenousAdvisoryGroup;
            }
            if (name == "CALD Advisory Group") {
                return this.props.showCALDAdvisoryGroup;
            }
            if (name == "Youth Advisory Group") {
                return this.props.showYouthAdvisoryGroup;
            }
            if (name == "Consumer Advisory Group") {
                return this.props.showConsumerAdvisoryGroup;
            }
        return false;
    }

    render() {
        let links = menu.find(m => m.name === "about us").children.map((item, index) => {
            
            return !this.showItem(item.name) ? <div></div> : <div key={index} className="col-5 menu-card aboutus-card  my-2 mx-2">
                <div className="vertical-align-middle">
                    <Link to={item.route}>
                        <div style={{ height: "50px" }} dangerouslySetInnerHTML={{ __html: item.name }}></div>
                        <div className="py-3" >&#8594;</div >
                    </Link>
                </div>
            </div>;
        });

        return (<div className="container-spacing container pt-5  mb-4 page-content" id="SectionContainer" >
            <section className="content" > 
                <div className="container" >
                    <h1>Advisory Group</h1>
                    <p className="my-4"></p>
                    <div className="row">
                        {links}
                    </div>
                </div>
            </section>
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutPeople: state.siteData.siteData.aboutPeople,
        groupAdvisoryGroups: state.siteData.groupAdvisoryGroups,
        showIndigenousAdvisoryGroup: state.siteData.showIndigenousAdvisoryGroup,
        showCALDAdvisoryGroup: state.siteData.showCALDAdvisoryGroup,
        showYouthAdvisoryGroup: state.siteData.showYouthAdvisoryGroup,
        showConsumerAdvisoryGroup: state.siteData.showConsumerAdvisoryGroup,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const AdvisoryGroupsContainer = connect(mapStateToProps, mapDispatchToProps)(
    AdvisoryGroups
);

export default AdvisoryGroupsContainer;


// WEBPACK FOOTER //
// ./src/components/AboutUs/AdvisoryGroups.tsx